import { atom } from 'jotai';

import { TOASTS } from '@/constants/landing/toasts';

export const toastsAtom = atom<typeof TOASTS>(TOASTS);
